
import { TabType } from '@/components/common/TagTabs/TagTabs';
import {
  UsageHeaderFilterInput, UsageHeaderSortSortByInput,
  VarBillingUsageDetailFilterInput, VarBillingUsageDetailSort,
  VarBillingUsageDetailSortSortByInput, VarBillingUsageDetailStatusEnum
} from '@/graphql/contracts/_generated_/contracts';

export type UsageHeadersPayload = {
  after?: number;
  first?: number;
  sort?: UsageHeaderSortSortByInput
  group?: string;
  filter?: UsageHeaderFilterInput
  before?: string;
  last?: number;
};

export type ImportSuccessData = {
  count: number;
  embed_id: number;
  error_count: number;
  sheet_id: number;
  sheet_metadata: {
    original_file_name: string;
  }
  template_key: string;
};

export type UsageDetailsPayload = {
  after?: number;
  first?: number;
  sort?: VarBillingUsageDetailSortSortByInput;
  group?: VarBillingUsageDetailSort;
  filter?: VarBillingUsageDetailFilterInput;
  before?: string;
  last?: number;
};

export enum HeaderAction {
  MATCH,
  PROCESS
}

export enum TabKeys {
  ALL = 'ALL',
  MATCHED = 'MATCHED',
  UNMATCHED = 'UNMATCHED',
  FAILED_SO = 'FAILED_SO',
  IGNORED = 'IGNORED',
}

export const tabs: TabType[] = [
  {
    name: TabKeys.ALL,
    title: 'All rows',
  },
  {
    name: TabKeys.MATCHED,
    title: 'Matched rows',
  },
  {
    name: TabKeys.UNMATCHED,
    title: 'Unmatched rows',
  },
  {
    name: TabKeys.FAILED_SO,
    title: 'Failed SOs'
  },
  {
    name: TabKeys.IGNORED,
    title: 'Ignored'
  }
];

export const statusesMap = {
  [TabKeys.MATCHED]: [VarBillingUsageDetailStatusEnum.Matched],
  [TabKeys.UNMATCHED]: [VarBillingUsageDetailStatusEnum.MatchingError, VarBillingUsageDetailStatusEnum.Matching],
  [TabKeys.FAILED_SO]: [VarBillingUsageDetailStatusEnum.SalesOrdersGenerationError],
  [TabKeys.IGNORED]: [VarBillingUsageDetailStatusEnum.Ignored],
};